import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { PageHead } from "../GtaxShell";
import { DepositPanel } from "./DepositPanel";
import { KycPanel } from "./KycPanel";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/gtax`;
const LABEL = { pending: "Identity check pending", approved: "Approved", rejected: "Not approved" };

const saved = () => {
  try { return JSON.parse(sessionStorage.getItem("gtax_member")) || {}; } catch { return {}; }
};

export default function GtaxStatus() {
  const [params] = useSearchParams();
  const [ref, setRef] = useState(params.get("ref") || saved().reference || "");
  const [email, setEmail] = useState(params.get("email") || saved().email || "");
  const [member, setMember] = useState(null);
  const [error, setError] = useState("");

  const lookup = async (e) => {
    e?.preventDefault();
    setError("");
    try {
      const { data } = await axios.get(`${API}/status`, { params: { reference: ref.trim(), email: email.trim() } });
      setMember({ ...data, email: email.trim().toLowerCase() });
      sessionStorage.setItem("gtax_member", JSON.stringify({ reference: data.reference, email: email.trim().toLowerCase() }));
    } catch (err) {
      setMember(null);
      setError(err.response?.data?.detail || "Could not find your membership.");
    }
  };

  useEffect(() => { if (ref && email) lookup(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="gtax-status-page">
      <PageHead eyebrow="Member status" title="Your membership." sub="Enter your reference and email to see your verification status and settlement details." />
      <section className="pb-28">
        <div className="gx-wrap max-w-4xl space-y-8">
          <form onSubmit={lookup} className="gx-card p-8 grid md:grid-cols-[1fr_1fr_auto] gap-6 items-end" data-testid="gtax-status-form">
            <div><label className="block text-xs tracking-widest uppercase text-[color:var(--mute)]">Reference</label>
              <input value={ref} onChange={(e) => setRef(e.target.value)} placeholder="GTX-XXXXXXXX" className="w-full py-3 text-lg font-mono" data-testid="gtax-status-ref" /></div>
            <div><label className="block text-xs tracking-widest uppercase text-[color:var(--mute)]">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full py-3 text-lg" data-testid="gtax-status-email" /></div>
            <button className="gx-btn" data-testid="gtax-status-submit">Check</button>
          </form>
          {error && <p className="text-[#A0523F]" data-testid="gtax-status-error">{error}</p>}
          {member && (
            <div className="gx-card p-8 md:p-12 space-y-8" data-testid="gtax-status-result">
              <div className="flex flex-wrap justify-between gap-4">
                <div><div className="gx-eyebrow">{member.full_name}</div><div className="gx-serif text-3xl mt-2">{member.reference}</div></div>
                <div className="gx-serif text-2xl gx-gold" data-testid="gtax-status-kyc">{LABEL[member.kyc_status]}</div>
              </div>
              {member.kyc_status === "approved" && <DepositPanel record={member} address={member.treasury_address} compact />}
              {member.kyc_status === "pending" && <KycPanel record={member} />}
              {member.kyc_status === "rejected" && <p className="text-[color:var(--mute)]" data-testid="gtax-status-rejected">We could not approve your identity verification. Please contact us through the Contact page.</p>}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
